<template>
  <ion-page>
    <ion-header class="ion-no-border events-page-header liga-float-header signup-header">
      <ion-toolbar class="signup-float-toolbar">
        <div class="liga-float-bar signup-float-bar">
          <button type="button" class="liga-float-circle" aria-label="Назад" @click="navigate('login')">
            <ion-icon :icon="arrowBackOutline" />
          </button>
          <div class="liga-float-title-pill">
            <span class="liga-float-title-text">Регистрация</span>
          </div>
          <div class="liga-float-spacer" aria-hidden="true" />
        </div>
      </ion-toolbar>
    </ion-header>
    <ion-content class="main-background" :fullscreen="true" :scroll-y="true">
      <ion-card class="signup-card bg-transparent">
        <ion-card-content>
          <ion-input type="email" inputmode="email" placeholder="Электронная почта"
            v-model="registerAccount.email"></ion-input>
          <ion-input type="text" placeholder="Имя" v-model="registerAccount.firstName"></ion-input>
          <ion-input type="text" placeholder="Фамилия" v-model="registerAccount.lastName"></ion-input>
          <ion-input type="password" placeholder="Пароль" v-model="registerAccount.password"></ion-input>
          <ion-input type="password" placeholder="Пароль еще раз" v-model="confirmPassword"></ion-input>
          <div class="main-button-container">
            <ion-button v-on:click="singUp()" class="signup-button">
              Регистрация
            </ion-button>
          </div>
        </ion-card-content>
      </ion-card>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import { GlobalContext } from '@/model/globalcontext.model';
import router from '@/router/index';
import store from '@/store/index';
import { stripAuthWhitespace } from '@/utils/auth-input';
import { CapacitorHttp } from '@capacitor/core';
import {
    IonButton,
    IonCard,
    IonCardContent,
    IonContent,
    IonHeader,
    IonIcon,
    IonInput,
    IonPage,
    IonToolbar,
    alertController,
} from '@ionic/vue';
import axios from 'axios';
import { arrowBackOutline } from 'ionicons/icons';
import { defineComponent, inject } from 'vue';

export default defineComponent({
  props: {
    timeout: { type: Number, default: 1000 },
  },
  name: 'SignUp',
  components: {
    IonContent,
    IonPage,
    IonHeader,
    IonToolbar,
    IonCard,
    IonCardContent,
    IonInput,
    IonButton,
    IonIcon,
  },
  setup() {
    const emailPattern = new RegExp('[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{2,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})');
    const globalContext = inject('globalContext') as GlobalContext;
    const isMobile = globalContext.isMobile;

    return {
      arrowBackOutline,
      emailPattern,
      isMobile,
    }
  },
  data() {
    return {
      registerAccount: {
        login: '',
        email: '',
        firstName: '',
        lastName: '',
        password: ''
      },
      confirmPassword: '',
    }
  },

  ionViewWillEnter() {
    this.registerAccount = {
      login: '',
      email: '',
      firstName: '',
      lastName: '',
      password: ''
    };
    this.confirmPassword = '';
  },

  computed: {
    isAuthenticated: () => {
      return store.getters.authenticated;
    },
  },

  methods: {
    navigate(routeName: string): void {
      router.push(`/${routeName}`);
    },

    singUp(): void {
      const email = stripAuthWhitespace(this.registerAccount.email).toLowerCase();
      const password = stripAuthWhitespace(this.registerAccount.password);
      const confirmPassword = stripAuthWhitespace(this.confirmPassword);
      const firstName = this.registerAccount.firstName.trim();
      const lastName = this.registerAccount.lastName.trim();
      this.registerAccount.email = email;
      this.registerAccount.password = password;
      this.confirmPassword = confirmPassword;
      this.registerAccount.firstName = firstName;
      this.registerAccount.lastName = lastName;

      if (email.length < 1 || !this.emailPattern.test(email)) {
        this.showAlert('Ошибка', 'Укажите корректный адрес электронной почты');
        return;
      } else if (firstName.length < 1) {
        this.showAlert('Ошибка', 'Укажите Ваше имя');
        return;
      } else if (lastName.length < 1) {
        this.showAlert('Ошибка', 'Укажите Вашу фамилию');
        return;
      } else if (password.length < 4) {
        this.showAlert('Ошибка', 'Пароль должен быть не менее 4 символов');
        return;
      } else if (password !== confirmPassword) {
        this.showAlert('Ошибка', 'Указанные пароли не совпадают');
        return;
      }

      const data = {
        login: email,
        email,
        firstName,
        lastName,
        password,
      };

      if (this.isMobile) {
        const options = {
          url: `${process.env.VUE_APP_API_URL}api/signup`,
          data: data,
          headers: {
            'Content-Type': 'application/json'
          }
        };
        CapacitorHttp.post(options)
          .then((response) => {
            if (response.status === 400) {
              this.showAlert('Ошибка', 'Попробуйте другой email');
            } else {
              this.showAlert('Сообщение', 'Вы успешно зарегистрированы! Дождитесь активации аккаунта.');
              this.navigate('login');
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        axios
          .post('api/signup', data, {
            headers: { 'Content-Type': 'application/json' }
          })
          .then((response) => {
            if (response.status === 400) {
              this.showAlert('Ошибка', 'Попробуйте другой email');
            } else {
              this.showAlert('Сообщение', 'Вы успешно зарегистрированы! Дождитесь активации аккаунта.');
              this.navigate('login');
            }
          })
          .catch((err) => {
            if (err.message === 'Request failed with status code 400') {
              this.showAlert('Ошибка', 'Попробуйте другой email');
            }
          });
      }
    },

    async showAlert(alertTitle: string, alertMessage: string) {
      const alert = await alertController
        .create({
          header: alertTitle,
          message: alertMessage,
          buttons: ['OK'],
        });

      await alert.present();
    }
  }
});
</script>

<style scoped>
.signup-float-toolbar {
  --background: transparent;
  --border-width: 0;
  --padding-start: 0;
  --padding-end: 0;
  --padding-top: env(safe-area-inset-top);
  --min-height: 56px;
}
.signup-float-bar .liga-float-circle {
  appearance: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  color: var(--liga-chrome-text);
  flex-shrink: 0;
}
.signup-float-bar .liga-float-circle ion-icon {
  font-size: 22px;
  color: var(--liga-chrome-text);
}
.signup-float-bar .liga-float-spacer {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
}

.signup-card {
  margin: 12px 12px 24px;
  box-shadow: none;
}

ion-input {
  --background: var(--liga-float-glass-bg-strong);
  --color: var(--liga-chrome-text);
  --placeholder-color: var(--liga-chrome-text-muted);
  border-radius: 25px;
  font-family: 'Montserrat';
  margin-bottom: 1.25em;
  --padding-start: 2em;
  --padding-end: 2em;
  border: 1px solid var(--liga-float-glass-border);
  box-shadow: var(--liga-float-glass-shadow);
}

.signup-button {
  --background: var(--ion-color-orange);
  --background-activated: var(--ion-color-orange-tint);
  --color: #ffffff;
  width: 280px;
  height: 50px;
  font-family: 'Montserrat',
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
  font-weight: bold;
  --border-radius: 14px;
}

.main-button-container {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  margin-top: 0.5rem;
}
</style>